import React from 'react';

const SupplementalDocsDescription = () => (
  <>
    <p>Next, we’ll ask you to submit your updated supporting documents.</p>
    <p>
      If you have other non-VA health insurance information to update, you can
      submit it after you complete this form.
    </p>
    <p>
      <strong>Note:</strong> Don’t submit extra documents we didn’t request from
      you. This won’t make it faster to process your documents.
    </p>
  </>
);

export default SupplementalDocsDescription;
